import styled from '@emotion/styled';

export const Page = styled.div`
  height: 100%;
  position: relative;
  padding-top: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  @media screen and (max-width: 1279px) {
    padding-right: 1.5rem;
  }
  overflow: auto;
  scrollbar-width: none;
  border-radius: 32px 0px 0px 32px;
`;
